import React from 'react'
import {motion} from 'framer-motion';

import {
    PaddingContainer,
    Heading,
    FlexContainer,
    ParaText,
    IconContainer,
    Button,
} from '../../styles/Global.styled'
import { FaGithub } from 'react-icons/fa'
import { fadeInLeftVariant,fadeInRightVariant } from '../../utils/Variants'
import { ImageSlider } from '../ui/ImageSlider';
import ModalSlider from '../ui/ModalSlider';
import { TechStackCard, FixedBorderContainer } from '../../styles/MyProject.styled'
const Project = ({data}) => { 
  return (

    <FlexContainer fullWidthChild gap='100px'
        direction={data.reverse ? 'row-reverse' : false} 
    >
        {/** Left section project content */}
            <motion.div  
                variants={data.reverse ? fadeInLeftVariant : fadeInRightVariant} initial='hidden' whileInView='visible' viewport={{ once: false, amount: 0.4 }}
                >
                <FlexContainer align='left' gap='1rem'>
                    <Heading as='h3' size='h3' bottom='1rem'>
                        {data.project_name}
                    </Heading>
                    
                </FlexContainer>
                <PaddingContainer top='1rem'>
                    <FlexContainer gap='1.5rem' >
                        {data.tech_stack.map((stack, i) => (
                        <TechStackCard color={data.tech_color[i]}>
                        <Heading as='h4' size='h4' >{stack}</Heading>
                        </TechStackCard>
                        ))}
                    </FlexContainer>
                </PaddingContainer>
                <PaddingContainer tabletBottom='30px'>
                    <ParaText top='1.5rem' bottom='2rem'>
                        {data.project_desc}
                    </ParaText>
                    <FlexContainer gap='10px'>
                        <a href={data.project_url}><Button>Ir al Proyecto</Button></a> 

                        <ModalSlider images={data.project_imgs} />
                  </FlexContainer>
                </PaddingContainer>
           </motion.div>
        {/** right section project content */}
             <motion.div variants={data.reverse ? fadeInLeftVariant : fadeInRightVariant} initial='hidden' whileInView='visible' viewport={{ once: false, amount: 0.4 }} style={{ overflow: "visible", width: "100%" }}
>               <FixedBorderContainer >
                    <PaddingContainer >
                        <ImageSlider  images={data.project_imgs} />
                    </PaddingContainer>
                </FixedBorderContainer>
            </motion.div>
                    

    </FlexContainer>
    
  )
}

export default Project